namespace Matrix.Scheduling {
    export interface CalendarForm {
        CalendarCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        CalendarEntries: CalendarEntryGrid;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class CalendarForm extends Serenity.PrefixedContext {
        static formKey = 'Scheduling.Calendar';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CalendarForm.init)  {
                CalendarForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = CalendarEntryGrid;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(CalendarForm, [
                    'CalendarCode', w0,
                    'Name', w0,
                    'CalendarEntries', w1,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3
                ]);
            }
        }
    }
}
